// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9f8f9cc1","239":"6b1150bd","453":"8dd9db76","455":"a984b828"}[chunkId] + ".chunk.js";
};